import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';

const PieChart = () => {
  const [chartWidth, setChartWidth] = useState(window.innerWidth > 480 ? 280 : 200);

  useEffect(() => {
    const handleResize = () => {
      setChartWidth(window.innerWidth > 480 ? 280 : 200);
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const options = {
    chart: {
      type: 'pie',
    },
    labels: ['ONSITE', 'SOCIAL MEDIA', 'INSTAGRAM', 'FACEBOOK ', 'HOUSING '], // Labels for the pie chart
    legend: {
      show: false, // Hide default legend
    },
    colors: ['#FF5733', '#FFC300', '#DAF7A6', '#33FFF0', '#FF33A8'], // Custom colors for the slices
  };

  const series = [44, 55, 13, 43, 22]; // Data for the pie chart

  return (
    <div style={{ width: '100%', maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
      <h3 style={{ textAlign: 'center' }}>Leads by Source</h3>
      <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
        <ReactApexChart options={options} series={series} type="pie" width={chartWidth} />
      </div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '10px',
          marginTop: '20px',
        }}
      >
        {options.labels.map((label, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              margin: '5px 10px',
            }}
          >
            <span
              style={{
                display: 'inline-block',
                width: '12px',
                height: '12px',
                backgroundColor: options.colors[index],
                marginRight: '8px',
                borderRadius: '50%',
              }}
            ></span>
            <span style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
              {label}: {series[index]}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PieChart;
